import * as React from 'react';
import { TextField } from '@material-ui/core';
import { TextValidator } from 'react-material-ui-form-validator';
import { useFleetInputStyles } from './inputStyles';

const CustomInputText: React.FC<any> = ({
  className,
  validators,
  errorMessages,
  error,
  ...props
}) => {
  const classes = useFleetInputStyles();
  const cls = [classes.root, error && classes.error, className].filter(Boolean).join(' ');

  if (validators) {
    return (
      <TextValidator
        variant="outlined"
        className={cls}
        validators={validators}
        errorMessages={errorMessages}
        error={error}
        {...props}
      />
    );
  }

  return <TextField variant="outlined" className={cls} error={error} {...props} />;
};

export default CustomInputText;
